import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';

import * as actions from "redux/actions/NotebookActions";
import * as commonService from "utility/CommonService.js";

import NotebookForm from "components/NoteBooks/Form";

export const AddNoteBook = ({history}) => {
  const id = history.location.state.importNotebook
  const project = useSelector(state => state.projectReducer.project);
  const notebook = useSelector(state => state.notebookReducer.notebook);
  const defaultForm = {
    name: "",
    description: "",
    project_id: null,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getNotebook({id}))
  }, [dispatch, id])

  const handleSubmit = (newNotebook) => {
    const project_id = commonService.getSearchParams(history, "project");
    dispatch(
      actions.importNotebook({
        body: { notebook: { ...newNotebook, project_id }, importNotebook: notebook },
      })
    ).then((res) => {
      commonService.forSuccess("Notebook created successfully!", "Success");
      history.push({
        pathname: `/notebooks/${res.value.notebook.id}`,
         state: {
           project: project
         }
      });
    });
  };
  return <NotebookForm defaultForm={defaultForm} handleSubmit={handleSubmit} history={history} />;
};

export default AddNoteBook;
